import Link from "next/link";
import React from "react";
import FilledButton from "@/components/common/filled-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const GetFreeAccessButton = () => {
  const { hideModal } = useGlobalModalContext();

  return (
    <Link href={"/get-free-access"} onClick={hideModal}>
      <FilledButton text={"Get Free Access"} padding={"8px 12px"} />
    </Link>
  );
};

export default GetFreeAccessButton;
